/**
 * @see {@link reactApp/appHelpers/featuresHelpers/features/docs/quotaCleaner.md} Документация по фичам чистилки
 */

import { IS_BIZ_USER, IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { features } from 'reactApp/mail-features';
import type { UserQuotaGroupId } from 'reactApp/types/QuotaCleaner';

const fastCleanCondition = !IS_BIZ_USER;

/**
 * CLOUDWEB-19209
 * Доступности чистилки для платных пользователей
 */

export const quotaCleanerForPaid = features.has('quota-cleaner-for-paid');

/**
 * CLOUDWEB-19803
 * Доступность чистилки по ссылке, задаваемой quotaCleanerDirectLinkQs
 */
export const quotaCleanerByLink = features.has('quota-cleaner-by-link');

/**
 * CLOUDWEB-19761
 * Включалка быстрой чистилки
 */
export const quotaCleanerFastEnable = fastCleanCondition && features.has('quota-cleaner-fast-enable');

/**
 * CLOUDWEB-20137
 * Включалка быстрой чистилки для мобильных устройств
 */
export const quotaCleanerFastEnableMob = fastCleanCondition && features.has('quota-cleaner-fast-enable-mob');

const defaultFastCleanPriority = [
    'cloudBin',
    'mailSpam',
    'mailBin',

    // Категории для сейфования,
    // пока выключаем
    // 'cloudOld',
    // 'mounted',
    // 'cloudLarge',
    // 'newsletters',
    // 'oldSent',
    // 'oldInbox',
    // 'largeInbox',
    // 'largeSent',
    // 'backup',
    // 'cameraUploads',
    // 'video',
    // 'read',
] as UserQuotaGroupId[];

/**
 * CLOUDWEB-19761
 * Список доступных групп быстрой чистилки в порядке приоритета
 * наличие группы в массиве означает две вещи:
 * - группа доступна для очистки быстрой чистилкой
 * - группа имеет определенный приоритет для очистки, задаваемый её положением в массиве
 */
export const quotaCleanerFastGroupsByPriority = features.getAsArray(
    'quota-cleaner-fast-groups-by-priority',
    defaultFastCleanPriority
) as UserQuotaGroupId[];

/**
 * CLOUDWEB-19761
 * Отладочный вывод для функционала чистилки
 */
export const quotaCleanerDebug = features.has('quota-cleaner-debug');

/**
 * CLOUDWEB-19978
 * Таймаут на длительность быстрой очистки
 * Техническая фича
 */
export const fastCleanTimeoutSec = features.getAsInt('fast-clean-timeout-sec', 40);

/**
 * CLOUDWEB-19978
 * Сколько групп сейфовать за один запрос при быстрой очистке
 * Техническая фича, чтобы выкатить логику выключенной
 */
export const fastCleanSafeBatchSize = features.getAsInt('fast-clean-safe-batch-size', 3);

/**
 * CLOUDWEB-19978
 * Количество ретраев для быстрой очистки
 * Техническая фича
 */
export const fastCleanRetryCount = features.getAsInt('fast-clean-retry-count', 1);

/**
 * CLOUDWEB-19787
 * Ссылка на хелп о сейфе
 */
export const quotaCleanerSafeHelpLink = features.getAsString('quota-cleaner-safe-help-link', 'https://help.mail.ru/cloud_web/size/safe/');

/**
 * CLOUDWEB-19820
 * Паттерны для определения точек входа в чистилку,
 * можно указывать весь url или только строку параметров, начиная c ?
 */
export const quotaCleanerFromMailQs = features.getAsString(
    'quota-cleaner-from-mail-qs',
    '?utm_source=mail_web&utm_medium=web_union_quota_landing&utm_campaign=new_block_overquota_cleaner'
);
export const quotaCleanerDirectLinkQs = features.getAsString('quota-cleaner-direct-link-qs', '?action=quota-cleaner');
export const quotaCleanerInstantFastCleanQs = features.getAsString('quota-cleaner-instant-fast-clean-qs', '?action=fast-clean-start');

export const quotaCleanerOnboardingEntryEnable = features.has('quota-cleaner-onboarding-entry-enable');

/**
 * CLOUDWEB-20328
 * Включение видео-обложек в модалках
 */
export const quotaCleanerMobileVideoCovers = IS_MOBILE_BROWSER ? features.has('quota-cleaner-mobile-video-covers') : true;
